export const industriesRoutes = {
    api: {
        base: (): string => '/industries',
    },
};

